import { subDays } from 'date-fns';
export var mockData = [
    {
        id: 1,
        workspaceId: 7,
        isActive: true,
        isEdited: true,
        isCopy: true,
        isDownload: true,
        isSendToEmail: true,
        isShareAnyone: true,
        isShareExternally: true,
        isShareViaLink: true,
        isRequestAccess: true,
        isPrint: true,
        isDeleteTrash: true,
        isRenameMove: true,
        isPublish: true,
        except: 'OWNER',
        createdAt: subDays(new Date(), 4).toISOString(),
        updatedAt: subDays(new Date(), 4).toISOString(),
        documentAlertConfigList: [
            {
                id: 1,
                documentId: 59078,
                documentAlertConfigId: 1,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Meeting Minutes'
            }
        ]
    },
    {
        id: 2,
        workspaceId: 7,
        isActive: true,
        isEdited: true,
        isCopy: false,
        isDownload: false,
        isSendToEmail: true,
        isShareAnyone: true,
        isShareExternally: false,
        isShareViaLink: true,
        isRequestAccess: true,
        isPrint: true,
        isDeleteTrash: true,
        isRenameMove: true,
        isPublish: false,
        except: null,
        createdAt: subDays(new Date(), 4).toISOString(),
        updatedAt: subDays(new Date(), 4).toISOString(),
        documentAlertConfigList: [
            {
                id: 2,
                documentId: 59078,
                documentAlertConfigId: 2,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Legal Agreement'
            },
            {
                id: 3,
                documentId: 59092,
                documentAlertConfigId: 2,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Employee Handbook'
            },
            {
                id: 4,
                documentId: 59095,
                documentAlertConfigId: 2,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Company Policies'
            },
            {
                id: 5,
                documentId: 57896,
                documentAlertConfigId: 2,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Employee Handbook-2'
            }
        ]
    },
    {
        id: 3,
        workspaceId: 7,
        isActive: true,
        isEdited: false,
        isCopy: false,
        isDownload: false,
        isSendToEmail: false,
        isShareAnyone: true,
        isShareExternally: false,
        isShareViaLink: true,
        isRequestAccess: true,
        isPrint: true,
        isDeleteTrash: true,
        isRenameMove: true,
        isPublish: false,
        except: null,
        createdAt: subDays(new Date(), 4).toISOString(),
        updatedAt: subDays(new Date(), 4).toISOString(),
        documentAlertConfigList: [
            {
                id: 6,
                documentId: 59078,
                documentAlertConfigId: 3,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Q1 Financial Report 2024'
            },
            {
                id: 9,
                documentId: 57896,
                documentAlertConfigId: 3,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Q2 Financial Report 2024'
            },
            {
                id: 10,
                documentId: 57867,
                documentAlertConfigId: 3,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Q3 Financial Report 2024'
            },
            {
                id: 11,
                documentId: 57868,
                documentAlertConfigId: 3,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Q4 Financial Report 2024'
            },
            {
                id: 12,
                documentId: 57866,
                documentAlertConfigId: 3,
                createdAt: subDays(new Date(), 4).toISOString(),
                updatedAt: subDays(new Date(), 4).toISOString(),
                title: 'Annual Financial Report 2024'
            }
        ]
    },
    {
        id: 4,
        workspaceId: 7,
        isActive: true,
        isEdited: true,
        isCopy: true,
        isDownload: true,
        isSendToEmail: true,
        isShareAnyone: true,
        isShareExternally: true,
        isShareViaLink: true,
        isRequestAccess: true,
        isPrint: true,
        isDeleteTrash: true,
        isRenameMove: true,
        isPublish: true,
        except: null,
        createdAt: subDays(new Date(), 3).toISOString(),
        updatedAt: subDays(new Date(), 3).toISOString(),
        documentAlertConfigList: [
            {
                id: 13,
                documentId: 61745,
                documentAlertConfigId: 4,
                createdAt: subDays(new Date(), 3).toISOString(),
                updatedAt: subDays(new Date(), 3).toISOString(),
                title: 'Budget 2025'
            }
        ]
    }
];
